import { createContext, FunctionComponent, useEffect } from "react";
import { useAppReady } from "@src/taskpane/hooks/useAppReady";
import { captureErrorInfo } from "@src/taskpane/helpers/errorHandler";
import { DocumentSettings } from "@src/lib/settings/DocumentSettings";
import { defaultAppState, useAppState } from "@src/taskpane/providers/walter/app-state";
import { AppSetup } from "@src/taskpane/components/AppSetup";

export const WalterContext = createContext(defaultAppState);

export const WalterProvider: FunctionComponent = ({ children }) => {
  const { isAppReady: appReady } = useAppReady();
  const { state, setCurrentUser, switchWorkspace, dispatch } = useAppState();

  useEffect(() => {
    if (appReady) dispatch({ type: "SET_PLATFORM", payload: Office.context.platform });
  }, [appReady]);

  useEffect(() => {
    if (appReady) {
      // By default, show the taskpane when the document is opened.
      DocumentSettings.get("Office.AutoShowTaskpaneWithDocument")
        .then(async (autoShow) => {
          await DocumentSettings.set("Office.AutoShowTaskpaneWithDocument", autoShow ?? true);
        })
        .catch(captureErrorInfo);
    }
  }, [appReady]);

  const contextValue = { ...state, setCurrentUser, switchWorkspace };

  return (
    <WalterContext.Provider value={contextValue}>
      <AppSetup setCurrentUser={setCurrentUser} switchWorkspace={switchWorkspace} />
      {children}
    </WalterContext.Provider>
  );
};
